import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Heart, Clock, Trash2 } from 'lucide-react';
import { Price } from '../context/CurrencyContext';

export const WishlistSection = ({ items, onRemove }) => {
  const navigate = useNavigate();

  return (
    <Card className="border-0 shadow-lg" data-testid="wishlist-section">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-2xl flex items-center"><Heart className="w-6 h-6 mr-2 fill-rose-500 text-rose-500" /> My Wishlist</CardTitle>
        <span className="text-sm text-gray-500" data-testid="wishlist-count">{items.length} saved</span>
      </CardHeader>
      <CardContent>
        {items.length === 0 ? (
          <div className="text-center py-10">
            <Heart className="w-14 h-14 text-gray-300 mx-auto mb-3" />
            <p className="text-gray-500 mb-4" data-testid="wishlist-empty">Tap the heart on any destination or package to save it here</p>
            <Button onClick={() => navigate('/destinations')} variant="outline" className="border-2 border-teal-500 text-teal-600 hover:bg-teal-50">Browse Destinations</Button>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((w) => {
              const item = w.destination || w.package;
              const isPkg = w.item_type === 'package';
              return (
                <div key={`${w.item_type}-${w.item_id}`} data-testid={`wishlist-item-${w.item_type}-${w.item_id}`} className="group rounded-xl overflow-hidden border border-gray-100 bg-white hover:shadow-lg transition-shadow">
                  <div className="relative h-36 cursor-pointer" onClick={() => navigate(isPkg ? `/packages/${w.item_id}` : '/destinations')}>
                    <img src={item.image} alt={item.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <span className="absolute top-2 left-2 bg-white/90 text-xs font-semibold px-2 py-0.5 rounded-full capitalize">{w.item_type}</span>
                  </div>
                  <div className="p-4">
                    <h4 className="font-bold text-gray-900 truncate">{item.name}</h4>
                    <div className="flex items-center justify-between text-sm mt-1 mb-3">
                      <Price inr={item.price} className="text-teal-600 font-semibold" />
                      <span className="flex items-center text-gray-500"><Clock className="w-4 h-4 mr-1" />{item.duration}</span>
                    </div>
                    <div className="flex gap-2">
                      <Button size="sm" data-testid={`wishlist-book-${w.item_type}-${w.item_id}`} onClick={() => navigate('/booking', { state: isPkg ? { package: item } : { destination: item } })} className="flex-1 bg-gradient-to-r from-teal-500 to-cyan-600 text-white">Book</Button>
                      <Button size="sm" variant="ghost" data-testid={`wishlist-remove-${w.item_type}-${w.item_id}`} onClick={() => onRemove(w.item_type, w.item_id)} className="text-red-600 hover:bg-red-50" aria-label="Remove"><Trash2 className="w-4 h-4" /></Button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
